import { jsx as _jsx } from "react/jsx-runtime";
import { RouteOff } from 'lucide-react';
import { useMemo } from 'react';
import { useInitialSettings } from '../context/settings';
import { useFormikContext } from 'formik';
import { useSelectedAccount } from '../context/swapAccounts';
import { ICON_CLASSES_WARNING } from '../components/Pages/Swap/Form/SecondaryComponents/validationError/constants';
import { isExtendedSourceNetwork } from '../lib/extendedRoutes/registry';
export function useRouteValidation(quoteError, hasQuote, _isQuoteLoading, autoSlippageWouldWork) {
    const { values } = useFormikContext();
    const { to, from, destination_address } = values;
    const selectedSourceAccount = useSelectedAccount("from", from?.name);
    const initialSettings = useInitialSettings();
    const quoteErrorCode = quoteError?.response?.data?.error?.code || quoteError?.code;
    const quoteErrorMessage = quoteError?.response?.data?.error?.message || quoteError?.message;
    let validationMessage = '';
    let validationDetails = {};
    if (!hasQuote && autoSlippageWouldWork) {
        validationDetails = { title: 'Route Unavailable', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        validationMessage = `This might be because of high slippage, try switching the slippage percentage to "Auto"`;
    }
    if (((from?.name && from?.name.toLowerCase() === initialSettings.sameAccountNetwork?.toLowerCase()) || (to?.name && to?.name.toLowerCase() === initialSettings.sameAccountNetwork?.toLowerCase()))) {
        const network = from?.name.toLowerCase() === initialSettings.sameAccountNetwork?.toLowerCase() ? from : to;
        if ((selectedSourceAccount && destination_address && selectedSourceAccount?.address?.toLowerCase() !== destination_address?.toLowerCase())) {
            validationMessage = `Transfers between ${network?.display_name} and other chains are only allowed within the same account. Please make sure you're using the same address on both source and destination.`;
            validationDetails = { title: 'Action Needed', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        }
        if (values.depositMethod === "deposit_address") {
            validationMessage = `Manually transferring between ${from?.display_name} and ${to?.display_name} networks is not supported.`;
            validationDetails = { title: 'Manual Transfer is not supported', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        }
    }
    if (quoteErrorCode === "QUOTE_REQUIRES_NO_DEPOSIT_ADDRESS" && !isExtendedSourceNetwork(from?.name)) {
        validationDetails = { title: 'Manual swapping is not supported', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        validationMessage = `Swaps via manual transfer are not supported for this route. Please select a wallet to send from.`;
    }
    if (quoteErrorCode === "PRICE_IMPACT_TOO_HIGH") {
        validationDetails = { title: 'Price impact too high', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        validationMessage = `The price impact for this amount is too high to swap. Try a smaller amount.`;
    }
    if (quoteErrorCode === "ROUTE_NOT_FOUND_ERROR" && quoteErrorMessage === "Rate not available") {
        validationDetails = { title: 'Rate not available', type: 'warning', icon: _jsx(RouteOff, { className: ICON_CLASSES_WARNING }) };
        validationMessage = `A rate is not available for this route or amount.`;
    }
    const value = useMemo(() => ({
        message: validationMessage,
        details: validationDetails
    }), [validationMessage, validationDetails]);
    return value;
}
